import { DEFAULT_CATEGORY_SECTION } from '../../product/category-section'
import { toAudiencePayload } from '../../../helpers/audience-payload'
import {
  CreateCategoryPayload,
  ListCategoryDoc,
} from '../../../redux-toolkits/categories/categories.type'

export const getCategoryInitialValues = (category?: ListCategoryDoc) => ({
  icon: category?.icon ?? '',
  name: category?.name ?? '',
  description: category?.description ?? '',
  comboTagLine: category?.comboTagLine ?? '',
  recommendedTagLine: category?.recommendedTagLine ?? '',
  isActive: category?.isActive ?? true,
  section: category?.section ?? DEFAULT_CATEGORY_SECTION,
  ageRange: category?.ageRange ?? null,
  genders: category?.genders ?? [],
})

export type CategoryFormValues = ReturnType<typeof getCategoryInitialValues>

export const toCategoryPayload = (
  values: CategoryFormValues,
): CreateCategoryPayload => ({
  ...values,
  ...toAudiencePayload(values),
})
